/**
 * THIS BLOCK IS NOT READY AND IT'S CURRENTLY REMOVED FROM GUTENBERG
 */

import { Box, Stack, BoxProps } from '@chakra-ui/react';
import FullWidthBlock from '../FullWidthBlock';
import { CoreBlock } from '../../types';

interface CoreCoverProps {
  block: CoreBlock & {
    attrs?: CoreBlock['attrs'] & {
      url?: string;
      dimRatio?: number;
      overlayColor?: string;
      focalPoint?: { x: number; y: number };
    };
  };
  renderBlocks: (block: CoreBlock, i: number) => JSX.Element;
  boxProps?: BoxProps;
}

const CoreCover: React.FC<CoreCoverProps> = ({
  block,
  renderBlocks,
  boxProps = {},
}) => {
  const {
    align,
    url,
    dimRatio = 50,
    overlayColor = 'rgba(0,0,0,0.5)',
    focalPoint,
  } = block.attrs || {};

  const Wrapper = align === 'full' ? FullWidthBlock : Box;

  const backgroundPosition = focalPoint
    ? `${focalPoint.x * 100}% ${focalPoint.y * 100}%`
    : 'center';

  return (
    <Wrapper
      position="relative"
      bgImage={url ? `url(${url})` : undefined}
      bgSize="cover"
      bgPos={backgroundPosition}
      color="white"
      py={20}
      px={4}
      {...boxProps}
    >
      {/* Overlay */}
      <Box
        position="absolute"
        inset={0}
        bg={overlayColor}
        opacity={dimRatio / 100}
        zIndex={0}
      />

      {/* Content */}
      <Box position="relative" zIndex={1}>
        <Stack spacing={6} align="center" textAlign="center">
          {block.innerBlocks?.map(renderBlocks)}
        </Stack>
      </Box>
    </Wrapper>
  );
};

export default CoreCover;
